export default "__VITE_ASSET__e2ddb68f__"